import axiosInstance from "../config/axiosInstance";

export const unwrapApiPayload = (response) =>
  response?.data?.data ?? response?.data ?? response ?? null;

export const unwrapApiItems = (response) => {
  const payload = unwrapApiPayload(response);
  if (Array.isArray(payload)) return payload;
  return payload?.items ?? payload?.data ?? [];
};

export const getShareholderDocuments = async (languageCode = "vi") =>
  unwrapApiItems(await axiosInstance.get(`/shareholder-documents/${languageCode}`));

export const getShareholderDocumentCategories = async (languageCode = "vi") =>
  unwrapApiItems(
    await axiosInstance.get(`/shareholder-document-categories/${languageCode}`),
  );

export const getAdminShareholderDocumentCategories = (params = {}) =>
  axiosInstance
    .get("/admin/shareholder-document-categories/getAll", { params })
    .then(unwrapApiPayload);

export const getAdminShareholderDocuments = (params = {}) =>
  axiosInstance
    .get("/admin/shareholder-documents/getAll", { params })
    .then(unwrapApiPayload);

export const getAdminShareholderDocument = (id) =>
  axiosInstance
    .get(`/admin/shareholder-documents/${id}`)
    .then(unwrapApiPayload);

export const createShareholderDocument = (data) =>
  axiosInstance.post("/admin/shareholder-documents", data).then(unwrapApiPayload);

export const updateShareholderDocument = (id, data) =>
  axiosInstance
    .put(`/admin/shareholder-documents/${id}`, data)
    .then(unwrapApiPayload);

export const deleteShareholderDocument = (id) =>
  axiosInstance
    .delete(`/admin/shareholder-documents/${id}`)
    .then(unwrapApiPayload);

export const uploadShareholderDocument = async (file) => {
  const body = new FormData();
  body.append("file", file);
  const response = await axiosInstance.post("/admin/upload-documents", body, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return unwrapApiPayload(response);
};
